/* global globalThis */
import trace from '~/lib/trace';
import React from 'react';
import {createRoot} from 'react-dom/client';

import App from './App';

const bootstrap = async () => {
  const container = document.getElementById('root');
  const root = createRoot(container);
  root.render(<App />);
};

const addDomReadyListener =
  typeof globalThis.addEventListener === 'function'
    ? globalThis.addEventListener.bind(globalThis)
    : globalThis.window?.addEventListener?.bind(globalThis.window);

addDomReadyListener?.('DOMContentLoaded', () => {
  bootstrap().catch(trace);
});
